import React from "react";
import { motion } from "framer-motion";
import { pageVariants } from "../animations/pageTransitions"; // Import animation config
import "./Capabilities.css";
import oncology from "../../practices_images/oncology.jpg"; // Ensure this path is correct
import CollapsibleSection from "./CollapsibleSection"; // adjust path if needed

const Oncology = () => {
  return (
  <motion.div
    variants={pageVariants}
    initial="initial"
    animate="animate"
    exit="exit"
  >
    <div className="cap-container">
      <h1>Oncology</h1>

      <div className="cap-section">
        <div className="text-content">
          {/* ✅ First 2 sections: normal (always visible) */}
          <h3>Supporting care where precision and coordination matter most</h3>
          <p>
            Oncology practices operate in an environment defined by complexity, sensitivity, and constant change. Treatment plans are highly individualized, care is often delivered over long periods of time, and operational accuracy is essential to both clinical and financial outcomes.
          </p>
          <p>
            We partner with oncology practices to help them navigate this complexity with clarity, consistency, and control.
          </p>

          <h3>The Reality of Oncology Care</h3>
          <p>
            Oncology care requires close coordination across clinical teams, infusion services, diagnostics, and payers. Documentation must be precise. Authorization and reimbursement processes are rigorous. Financial exposure is high when systems are misaligned.          </p>
          <p>
            These demands place significant pressure on providers and staff, particularly as practices manage growing patient volumes and evolving treatment protocols.
          </p>

          {/* ✅ Everything after: collapsible */}
          <CollapsibleSection title="Our Role">
            <p>
              We help oncology practices strengthen the operational and financial structures that support high quality, patient centered care.
            </p>
            <p>
              Our work focuses on reinforcing documentation and coding accuracy, supporting reliable billing and authorization workflows, improving financial visibility, and aligning administrative processes with the realities of oncology care delivery.
            </p>
            <p>
              We take a disciplined approach that prioritizes compliance, accuracy, and sustainability.
            </p>
          </CollapsibleSection>

          <CollapsibleSection title="Creating Stability in a High Stakes Environment">
            <p>
              Our goal is to help practices operate with confidence in an inherently high stakes setting.
            </p>
            <p>
              By improving operational consistency and financial insight, we support reduced administrative burden, stronger revenue predictability, and better coordination across care teams. This allows clinicians to remain focused on patient care while leadership maintains control over practice performance.
            </p>
          </CollapsibleSection>

          <CollapsibleSection title="Looking Ahead">
            <p>
              As oncology care continues to advance, the importance of strong operational foundations only increases.
            </p>
            <p>
              We work with practices to build the structure and discipline required to support patients through complex treatment journeys while maintaining long term organizational stability.
            </p>
            <p>
              Let’s begin a conversation about how your practice can move forward with clarity and purpose.
            </p>
          </CollapsibleSection>
        </div>

        {/* Image Section */}
        <div className="image-container">
          <img src={oncology} alt="Oncology" />
        </div>

      </div>
    </div>
  </motion.div>
  );
};

export default Oncology;
